import { QuoteWorkspaceProvider } from 'contexts/quote-workspace.context';
import { useCallback, useEffect, useRef } from 'react';
import { DisclaimerContext, DisclaimerProvider } from 'routes/smart-quote/components/disclaimer';
import { SmartQuoteHeader } from 'routes/smart-quote/components/header';
import { LearnMoreWarning } from 'routes/smart-quote/components/learn-more-warning';
import { SmartQuoteMain } from 'routes/smart-quote/components/main';
import { OnboardingList } from 'routes/smart-quote/components/onboarding-list';
import PromptConfiguratorFooter from 'routes/smart-quote/components/prompt-configurator';
import { useHasActiveTabSmartQuotePrompts } from 'routes/smart-quote/hooks/use-sort-prompts';
import { trackSmartQuoteEvent } from 'routes/smart-quote/utils';

import './style.scss';

const SmartQuotePage = () => {
  const pageRef = useRef<HTMLDivElement>(null);
  const hasPrompt = useHasActiveTabSmartQuotePrompts();

  // hide the body scrollbar for this page as it interferes with this page's scrollbar when several aggrid are displayed.
  useEffect(() => {
    document.body.classList.add('smart-quote-lock-body-scroll');
    return () => {
      document.body.classList.remove('smart-quote-lock-body-scroll');
    };
  }, []);

  const trackDisclaimer: DisclaimerContext['close'] = useCallback(reason => {
    trackSmartQuoteEvent('disclaimer', `close - ${reason}`);
  }, []);

  return (
    <DisclaimerProvider onClose={trackDisclaimer}>
      <main className="d-flex flex-column flex-grow-1 smart-quote-ws scrollbar-sm position-relative" ref={pageRef}>
        <SmartQuoteHeader />
        <div className="container-lg flex-y flex-grow-1">
          <div className="flex-y gap-1 px-2 flex-grow-1 px-lg-24px justify-content-center">
            <SmartQuoteMain pageRef={pageRef} />
            <PromptConfiguratorFooter pageRef={pageRef} />
            <OnboardingList />
          </div>
          {!hasPrompt && <LearnMoreWarning className="px-lg-24px" />}
        </div>
      </main>
    </DisclaimerProvider>
  );
};

export default function SmartQuoteWorkspace() {
  return (
    <QuoteWorkspaceProvider value="smartQuote">
      <SmartQuotePage />
    </QuoteWorkspaceProvider>
  );
}
